import { COPY } from '../../copy/firstRun'
import { writeErrorLine } from '../../lib/writeError'
import { RECESS } from './grounds'

/**
 * The line that says a consent answer was not stored: first run's own `frErrorSave`, or the busy sentence
 * when the server was busy (`writeErrorLine`), on a recessed ground of its own. Over the page gradient the
 * line crossed the tan peak at about 3:1 (measured), and this is the one line that says nothing was
 * recorded, so it keeps its ground. One component for the three places that can fail to store an answer
 * (the first-run ask, the ask a "Read and agree" opens, and the withdrawal), so they cannot word it apart.
 */
export function WriteFailureNote({ error, className = '' }: { error: unknown; className?: string }) {
  return (
    <p
      role="alert"
      className={`rounded-lg px-3 py-2 text-[13px] text-(--warn-terracotta-text) ${className}`}
      style={{ backgroundColor: RECESS }}
    >
      {writeErrorLine(error, COPY.frErrorSave)}
    </p>
  )
}
